import { render, staticRenderFns } from "./InternshipDetails.vue?vue&type=template&id=3c777a02&"
import script from "./InternshipDetails.vue?vue&type=script&lang=js&"
export * from "./InternshipDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports